// extracted by mini-css-extract-plugin
export default {"root":"qgdKCMwL8Ujvx8E7D_m0","textWrapper":"Eg5cLVBecxvSAd_xrQUZ","subTitle":"hQQy19Lj88KuT0GBs7wh","actions":"ToNJ07Q3ZEM4QXI79Pb2"};